import useAuth from '@giro/shared-hooks/useAuth.hook';
import { resolvePdvAccess } from '@giro-pdv/modules/pdv/pdvRoute.util';

export default function usePdvAccess() {
  const { user } = useAuth();
  return resolvePdvAccess(user?.user?.codes?.segment);
}
